import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../direct/DismissBackground.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_atBottomCenterphs4xo2ro2dv as get_atBottomCenter,
} from '../helpers.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../models/Theme.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../direct/ContainingView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { overlayWriter1bxnhxr8o82ue as overlayWriter } from '../ViewContextExtensions.commonHtml.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from '../RView.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../ViewWrapper.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../models/data.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../direct/Space.commonHtml.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  delayolwo40i9ucjz as delay,
  delay1diib1rb84y4j as delay_0,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function dialog(_this__u8e3s4, dismissable, content) {
  dismissable = dismissable === VOID ? true : dismissable;
  overlayWriter(_this__u8e3s4, true, VOID, ($this$overlayWriter, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (DismissBackground())($this$overlayWriter.pc());
    var tmp0_elvis_lhs = $this$overlayWriter.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$overlayWriter : tmp0_elvis_lhs;
    $this$overlayWriter.ebb(p, view);
    view.tbo(dialog$lambda$slambda_0(dismissable, close));
    var tmp = view.ibb(get_centered(view), view.hbb(DialogSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    content(view_0, () => {
      close();
      return Unit_instance;
    });
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    $this$overlayWriter.fbb(p, view);
    return Unit_instance;
  });
}
function toast(_this__u8e3s4, duration, content) {
  var tmp;
  if (duration === VOID) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp = toDuration(3, DurationUnit_SECONDS_getInstance());
  } else {
    tmp = duration;
  }
  duration = tmp;
  overlayWriter(_this__u8e3s4, false, VOID, ($this$overlayWriter, it) => {
    // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
    var tmp = $this$overlayWriter.tb5_1.vb3_1;
    var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
      var this_0 = tmp0_safe_receiver;
      var animate = get_animationsEnabled();
      try {
        if (animate) {
          set_animationsEnabled(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = this_0.__suppressMutationObserverClass;
          var tmp0_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
          var tmp_2;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().w();
            // Inline function 'kotlin.js.asDynamic' call
            this_0.__suppressMutationObserverClass = n;
            tmp_2 = n;
          } else {
            tmp_2 = tmp0_elvis_lhs;
          }
          var e = tmp_2;
          this_0.classList.add('notransition');
          var tmp1_elvis_lhs = this_0.getAttribute('class');
          e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        }
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = $this$overlayWriter.bbb_1;
        var tmp_3 = $this$overlayWriter;
        tmp_3.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          _this__u8e3s4.eb7(0.0);
          launch(_this__u8e3s4, VOID, VOID, toast$lambda$lambda$slambda_0(_this__u8e3s4, duration, $this$overlayWriter));
          return Unit_instance;
        };
        Companion_getInstance_0();
        var tmp_4 = get_atBottomCenter($this$overlayWriter);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())($this$overlayWriter.pc());
        var tmp0_elvis_lhs_0 = $this$overlayWriter.cbb_1;
        var p = tmp0_elvis_lhs_0 == null ? $this$overlayWriter : tmp0_elvis_lhs_0;
        $this$overlayWriter.ebb(p, view);
        view.xbm(true);
        view.zb8(get_rem(2));
        view.jbb(view.hbb(DialogSemantic_getInstance()), content(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Space())(view.pc());
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_0, view_0);
        view.fbb(p_0, view_0);
        $this$overlayWriter.fbb(p, view);
        $this$overlayWriter.jbb(tmp_4, view);
      }finally {
        if (animate) {
          var tmp_5 = window;
          tmp_5.setTimeout(() => {
            // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
            var this_1 = this_0;
            // Inline function 'kotlin.js.asDynamic' call
            var tmp = this_1.__suppressMutationObserverClass;
            var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.run' call
              var n = ArrayList().w();
              // Inline function 'kotlin.js.asDynamic' call
              this_1.__suppressMutationObserverClass = n;
              tmp_0 = n;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            var e = tmp_0;
            this_0.classList.remove('notransition');
            var tmp1_elvis_lhs = this_1.getAttribute('class');
            e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
            return Unit_instance;
          }, 100);
          set_animationsEnabled(true);
        }
      }
      tmp_0 = Unit_instance;
    }
    if (tmp_0 == null) {
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
      var prev_0 = $this$overlayWriter.bbb_1;
      var tmp_6 = $this$overlayWriter;
      tmp_6.bbb_1 = (_this__u8e3s4) => {
        var tmp0_safe_receiver = prev_0;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(_this__u8e3s4);
        _this__u8e3s4.eb7(0.0);
        launch(_this__u8e3s4, VOID, VOID, toast$lambda$lambda$slambda_2(_this__u8e3s4, duration, $this$overlayWriter));
        return Unit_instance;
      };
      Companion_getInstance_0();
      var tmp_7 = get_atBottomCenter($this$overlayWriter);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (RowOrCol())($this$overlayWriter.pc());
      var tmp0_elvis_lhs_2 = $this$overlayWriter.cbb_1;
      var p_1 = tmp0_elvis_lhs_2 == null ? $this$overlayWriter : tmp0_elvis_lhs_2;
      $this$overlayWriter.ebb(p_1, view_1);
      view_1.xbm(true);
      view_1.zb8(get_rem(2));
      view_1.jbb(view_1.hbb(DialogSemantic_getInstance()), content(view_1));
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Space())(view_1.pc());
      var tmp0_elvis_lhs_3 = view_1.cbb_1;
      var p_2 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
      view_1.ebb(p_2, view_2);
      view_1.fbb(p_2, view_2);
      $this$overlayWriter.fbb(p_1, view_1);
      $this$overlayWriter.jbb(tmp_7, view_1);
    }
    return Unit_instance;
  });
}
var dialog$lambda$slambdaClass;
function dialog$lambda$slambda() {
  if (dialog$lambda$slambdaClass === VOID) {
    class $ {
      constructor($dismissable, $close) {
        this.gdl_1 = $dismissable;
        this.hdl_1 = $close;
      }
      sao($completion) {
        if (this.gdl_1)
          this.hdl_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    dialog$lambda$slambdaClass = $;
  }
  return dialog$lambda$slambdaClass;
}
function dialog$lambda$slambda_0($dismissable, $close) {
  var i = new (dialog$lambda$slambda())($dismissable, $close);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var t = $this.idl_1.kba();
  var tmp = delay(1n, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.idl_1.eb7(1.0);
  var tmp_0 = delay(_Duration___get_inWholeMilliseconds__impl__msfiry($this.jdl_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.idl_1.eb7(0.0);
  var tmp_1 = delay_0(t.tb0_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  $this.kdl_1.sba($this.idl_1);
  return Unit_instance;
}
var toast$lambda$lambda$slambdaClass;
function toast$lambda$lambda$slambda() {
  if (toast$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$beforeNextElementSetup, $duration, $this_overlayWriter) {
        this.idl_1 = $$this$beforeNextElementSetup;
        this.jdl_1 = $duration;
        this.kdl_1 = $this_overlayWriter;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    toast$lambda$lambda$slambdaClass = $;
  }
  return toast$lambda$lambda$slambdaClass;
}
function toast$lambda$lambda$slambda_0($$this$beforeNextElementSetup, $duration, $this_overlayWriter) {
  var i = new (toast$lambda$lambda$slambda())($$this$beforeNextElementSetup, $duration, $this_overlayWriter);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var t = $this.ldl_1.kba();
  var tmp = delay(1n, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.ldl_1.eb7(1.0);
  var tmp_0 = delay(_Duration___get_inWholeMilliseconds__impl__msfiry($this.mdl_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.ldl_1.eb7(0.0);
  var tmp_1 = delay_0(t.tb0_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  $this.ndl_1.sba($this.ldl_1);
  return Unit_instance;
}
var toast$lambda$lambda$slambdaClass_0;
function toast$lambda$lambda$slambda_1() {
  if (toast$lambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$beforeNextElementSetup, $duration, $this_overlayWriter) {
        this.ldl_1 = $$this$beforeNextElementSetup;
        this.mdl_1 = $duration;
        this.ndl_1 = $this_overlayWriter;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    toast$lambda$lambda$slambdaClass_0 = $;
  }
  return toast$lambda$lambda$slambdaClass_0;
}
function toast$lambda$lambda$slambda_2($$this$beforeNextElementSetup, $duration, $this_overlayWriter) {
  var i = new (toast$lambda$lambda$slambda_1())($$this$beforeNextElementSetup, $duration, $this_overlayWriter);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  dialog as dialog2nk0sz8wudj8p,
  toast as toast3qlkoaxwmk6x7,
};
//endregion

//# sourceMappingURL=popoverHelpers.mjs.map
